export default "/developers-only";
